import { render } from "./History.vue?vue&type=template&id=5a21428b&scoped=true&bindings={}"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=5a21428b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a21428b"

export default script